import { defineStore } from 'pinia';
import { getHome, HomeRes, TaskItem } from '../service';
import { TaskTypeEnum, missionInfo } from '../config';

type State = {
    storage_home: string;
    isLiving: boolean;
    authorId: string;
    isInApp: boolean;
    shareBucket: string;
    homeData: HomeRes;
    allPointTake: number;
    allPointVote: number;
    toastFlag: boolean;
    toastData: {
        text: string;
        val: number;
    };
    isSecondPage: boolean;
}

export type FormatTaskItem = TaskItem & { text: string; btnText: string; doneText: string; };

export default defineStore('home',
    {
        state: (): State => ({
            storage_home: '0',
            isLiving: false,
            authorId: '',
            isInApp: true,
            shareBucket: '',
            homeData: {
                result: -1,
                bucket: '',
                curBucket: '',
                timeInfo: {
                    startTime: '',
                    endTime: '',
                },
                rankName: '',
                startGap: 0,
                // 当前用户可投票数
                point: 0,
                allPointTake: 0,
                // 当前用户被投票数
                votePoint: 0,
                uuid: '',
                taskList: [],
                avatar: '',
                username: '',
                pointGap: 0,
                rank: '',
                whiteUser: false,
            },
            allPointTake: 0, // 累计获取票数
            allPointVote: 0, // 累计投出票数
            toastFlag: false,
            toastData: {
                text: '',
                val: 0,
            },
            isSecondPage: true, // 是否是二级页面
        }),

        getters: {
            loading(): boolean {
                return this.homeData.result !== 1;
            },
            taskList(): FormatTaskItem[] {
                return this.homeData.taskList.filter(i => i.type !== TaskTypeEnum.SHARE_OPENED).map(i => ({
                    ...i,
                    ...missionInfo[i.type as TaskTypeEnum],
                }));
            },
            // 分享能否继续增加票数，即未达上限
            canAddSharePoint(): boolean {
                const val = this.homeData.taskList.find(i => i.type === TaskTypeEnum.SHARE);
                if (!val) return false;
                return val.status !== 101;
            },
            sharePointVal(): number {
                const val = this.homeData.taskList.find(i => i.type === TaskTypeEnum.SHARE);
                if (!val) return 0;
                return val.point || 0;
            },
            followPointVal(): number {
                const val = this.homeData.taskList.find(i => i.type === TaskTypeEnum.OFFICIAL);
                if (!val) return 0;
                return val.point || 0;
            },
            shareOpenedInfo(): TaskItem | undefined {
                const val = this.homeData.taskList.find(i => i.type === TaskTypeEnum.SHARE_OPENED);
                return val;
            },
            shareOpenData(): TaskItem | undefined {
                return this.homeData.taskList.find(i => i.type === TaskTypeEnum.SHARE_OPENED);
            },
        },

        actions: {
            // 获取主接口数据
            async getHomeData() {
                let p = null;
                if (!this.isInApp) {
                    p = getHome({ shareBucket: this.shareBucket });
                } else if (this.authorId) {
                    p = getHome({ authorId: +this.authorId });
                } else {
                    p = getHome();
                }
                return p.then(res => {
                    this.homeData = {
                        ...this.homeData,
                        ...res,
                    };
                });
            },
            // 获得票后toast弹窗
            showSuccessToast(text: string, val: number) {
                this.toastFlag = true;
                this.toastData.text = text;
                this.toastData.val = val;
                setTimeout(() => {
                    this.toastFlag = false;
                    this.toastData.text = '';
                    this.toastData.val = 0;
                }, 2000);
            },
            // 设置页面类型
            setPageSecondType(val: boolean) {
                this.isSecondPage = val;
            },
            updateFollowStatus() {
                this.homeData.taskList = this.homeData.taskList.map(i => {
                    return {
                        ...i,
                        status: i.type === TaskTypeEnum.OFFICIAL ? 101 : i.status,
                    };
                });
            },
            setEnv(val: boolean) {
                this.isInApp = val;
            },
            setBucket(val: string) {
                this.shareBucket = val;
            },
            setLivingRoom(val: boolean) {
                this.isLiving = val;
            },
            updateHomeStorage () {
                this.storage_home = `${+this.storage_home + 1}`;
                localStorage.setItem('global-midyear-my2home', this.storage_home);
            },
            setAuthorId(val: string) {
                this.authorId = val;
            },
        },
    });
